module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "adminsidebar"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/adminproposal"
    }
  }, [_vm._v("New Proposals")])], 1), _vm._v(" "), _c('li', [_vm._v("View Cart")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminpurchase"
    }
  }, [_vm._v("Purchase Products")])], 1), _vm._v(" "), _c('li', [_vm._v("Order Status")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminsuppliers"
    }
  }, [_vm._v("Suppliers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminsupplieritems"
    }
  }, [_vm._v("Supplier Products")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_vm._v("Monitoring Options")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminproducts"
    }
  }, [_vm._v("Apollo Products")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f776b106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminSidebar.vue
// module id = 168
// module chunks = 0